module.exports = __webpack_public_path__ + "assets/img/4.7e4d833f.jpg";